var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 73.3 81.5",
    style: {
      enableBackground: "new 0 0 73.3 81.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#4C54F3;}\n\t.st2{enable-background:new    ;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_985"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.3,5h-68c-1.1,0-2,0.9-2,2v68c0,1.1,0.9,2,2,2h68c1.1,0,2-0.9,2-2V7C72.3,5.9,71.4,5,70.3,5z M69.3,73.9 h-66V8h66V73.9z M49.3,41.6h9.2v-1.9h-9.2v-6.1h9.5v-1.8H47v16.5h2.2V41.6z M39.8,47.2c1.2-0.7,2.2-1.7,2.8-2.9 c0.7-1.3,1-2.8,1-4.5c0-2.6-0.8-4.6-2.3-6c-1.5-1.4-3.7-2.1-6.5-2.1h-5.5v16.5h6.2C37.2,48.3,38.6,47.9,39.8,47.2z M31.7,46.5 V33.5h3.2c2.1,0,3.8,0.5,4.9,1.6c1.1,1.1,1.7,2.6,1.7,4.7c0,1.4-0.2,2.5-0.7,3.5c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.5-2,0.8-3.2,0.8 H31.7z M15.4,41.8h4.8c1.8,0,3.1-0.5,4.2-1.4c1-0.9,1.5-2.2,1.5-3.7c0-1.6-0.5-2.8-1.5-3.7c-1-0.9-2.5-1.3-4.3-1.3h-6.9v16.5h2.2 V41.8z M15.4,33.5h4.4c2.6,0,3.8,1.1,3.8,3.2c0,2.2-1.2,3.3-3.8,3.3h-4.5V33.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,5h-68c-1.1,0-2,0.9-2,2v68c0,1.1,0.9,2,2,2h68c1.1,0,2-0.9,2-2V7C72.3,5.9,71.4,5,70.3,5z M69.3,73.9 h-66V8h66V73.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.5,33.1c-1-0.9-2.5-1.3-4.3-1.3h-6.9v16.5h2.2v-6.4h4.8c1.8,0,3.1-0.5,4.2-1.4c1-0.9,1.5-2.2,1.5-3.7 C26,35.1,25.5,33.9,24.5,33.1z M20,40.1h-4.5v-6.5h4.4c2.6,0,3.8,1.1,3.8,3.2C23.7,39,22.5,40.1,20,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M41.4,33.9c-1.5-1.4-3.7-2.1-6.5-2.1h-5.5v16.5h6.2c1.6,0,3-0.3,4.2-1c1.2-0.7,2.2-1.7,2.8-2.9 c0.7-1.3,1-2.8,1-4.5C43.7,37.3,42.9,35.3,41.4,33.9z M40.7,43.4c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.5-2,0.8-3.2,0.8h-3.7V33.5h3.2 c2.1,0,3.8,0.5,4.9,1.6c1.1,1.1,1.7,2.6,1.7,4.7C41.4,41.2,41.2,42.4,40.7,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.8,33.6v-1.8H47v16.5h2.2v-6.7h9.2v-1.9h-9.2v-6.1H58.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24.5,33.1c-1-0.9-2.5-1.3-4.3-1.3h-6.9v16.5h2.2v-6.4h4.8c1.8,0,3.1-0.5,4.2-1.4c1-0.9,1.5-2.2,1.5-3.7 C26,35.1,25.5,33.9,24.5,33.1z M20,40.1h-4.5v-6.5h4.4c2.6,0,3.8,1.1,3.8,3.2C23.7,39,22.5,40.1,20,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M41.4,33.9c-1.5-1.4-3.7-2.1-6.5-2.1h-5.5v16.5h6.2c1.6,0,3-0.3,4.2-1c1.2-0.7,2.2-1.7,2.8-2.9 c0.7-1.3,1-2.8,1-4.5C43.7,37.3,42.9,35.3,41.4,33.9z M40.7,43.4c-0.5,1-1.2,1.8-2.1,2.3c-0.9,0.5-2,0.8-3.2,0.8h-3.7V33.5h3.2 c2.1,0,3.8,0.5,4.9,1.6c1.1,1.1,1.7,2.6,1.7,4.7C41.4,41.2,41.2,42.4,40.7,43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58.8,33.6v-1.8H47v16.5h2.2v-6.7h9.2v-1.9h-9.2v-6.1H58.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/_icon_PDF.5b9fb0a5b1baade3baa5d411f84281c4.svg";
export { ForwardRef as ReactComponent };